import { Label, LabelVue2 } from './Label';
import { Error, ErrorVue2 } from './Error';
import { Hint, HintVue2 } from './Hint';
import { FloatingLabel, FloatingLabelVue2 } from './FloatingLabel';
export { FloatingLabel, FloatingLabelVue2, Label, LabelVue2, Error, ErrorVue2, Hint, HintVue2 };
